import {menuItems} from '../../data/menu.js';
import BonusUI from '../../data/bonusui';
import { getMenuItems } from '@/services/dataService';

const state = {
  data: menuItems.data,
  megamenu: BonusUI.data,
  allowedRoutes: [],
  filteredMenuItems: [],
  searchData: [],
  togglesidebar: true,
  activeoverlay : false,
  searchOpen : false,
  customizer: '',
  hideRightArrowRTL: false,
  hideLeftArrowRTL: true,
  hideRightArrow: true,
  hideLeftArrow: true,
  width: 0,
  height: 0,
  margin: 0,
  menuWidth: 0,
  miniSidebar: false,
};


const getters = {

};


const mutations = {
  opensidebar: (state) => {
    state.togglesidebar = !state.togglesidebar;
    if (window.innerWidth < 991) {
      state.activeoverlay = true;
    } else {
      state.activeoverlay = false;
    }
  },
  resizetoggle: (state) => {
    if (window.innerWidth < 1007) {
      state.togglesidebar = false;
    } else {
      state.togglesidebar = true;
    }
  },
  searchTerm: (state, term) => {
    let items = [];
    var searchval = term.toLowerCase();
    state.data.filter(menuItems => {
      
      if (menuItems.title) {
        if (menuItems.title.toLowerCase().includes(searchval) && menuItems.type === 'link') {
          items.push(menuItems);
        }
        if (!menuItems.children) return false;
        menuItems.children.filter(subItems => {
          if (subItems.title.toLowerCase().includes(searchval) && subItems.type === 'link') {
            subItems.icon = menuItems.icon;
            items.push(subItems);
          }
          if (!subItems.children) return false;
          subItems.children.filter(suSubItems => {
            if (suSubItems.title.toLowerCase().includes(searchval)) {
              suSubItems.icon = menuItems.icon;
              items.push(suSubItems);
            }
          });
        });
        state.searchData = items;
      }
    });
  },
  setBonusNavActive: (state, item) => {
    if (!item.active) {
      state.megamenu.forEach(a => {
        if (state.megamenu.includes(item))
          a.active = false;
        if (!a.children) return false;
        a.children.forEach(b => {
          if (a.children.includes(item)) {
            b.active = false;
          }
        });
      });
    }
    item.active = !item.active;
  },
  setNavActive: (state, item) => {
    if (!item.active) {
      state.data.forEach(a => {
        if (state.data.includes(item))
          a.active = false;
        if (!a.children) return false;
        a.children.forEach(b => {
          if (a.children.includes(item)) {
            b.active = false;
          }
        });
      });
    }
    item.active = !item.active;
  },
  setActiveRoute: (state, item) => {
    state.data.filter(menuItem => {
      if (menuItem !== item)
        menuItem.active = false;
      if (menuItem.children && menuItem.children.includes(item)){
        item.active = true;
        menuItem.active = true;
      }
      if (menuItem.children) {
        menuItem.children.filter(submenuItems => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            item.active = true;
            menuItem.active = true;
            submenuItems.active = true;
          }
        });
      }
    });
  },
  SET_MINI_SIDEBAR(state, value) {
    state.miniSidebar = value;
  },
  SET_ALLOWED_ROUTES(state, routes) {
    state.allowedRoutes = routes;
    localStorage.setItem('allowedRoutes', JSON.stringify(routes));
  },
  SET_FILTERED_MENU_ITEMS(state, items) {
    state.filteredMenuItems = items;
  },
  CLEAR_MENU_STATE(state) {
    state.allowedRoutes = [];
    state.filteredMenuItems = [];
    localStorage.removeItem('allowedRoutes');
  }
};

const actions = {
  opensidebar: (context, term) => {
    context.commit('opensidebar', term);
  },
  resizetoggle: (context, term) => {
    context.commit('resizetoggle', term);
  },
  setBonusNavActive: (context, term) => {
    context.commit('setBonusNavActive', term);
  },
  searchTerm: (context, term) => {
    context.commit('searchTerm', term);
  },
  setNavActive: (context, item) => {
    context.commit('setNavActive', item);
  },
  setActiveRoute: (context, item) => {
    context.commit('setActiveRoute', item);
  },
  toggleMiniSidebar({ commit, state }) {
    commit('SET_MINI_SIDEBAR', !state.miniSidebar);
  },
  initializeMenu({ commit, dispatch }) {
    const cachedRoutes = localStorage.getItem('allowedRoutes');
    if (cachedRoutes) {
      commit('SET_ALLOWED_ROUTES', JSON.parse(cachedRoutes));
      dispatch('filterMenuItems');
    }
    dispatch('fetchMenuItems');
  },
  async fetchMenuItems({ commit, dispatch }) {
    const token = localStorage.getItem('token_set');
    const profileId = localStorage.getItem('profile_id');
    
    if (!token || !profileId) return;

    try {
      const response = await getMenuItems(profileId, token);
      
      if (response && response.data && response.data.data) {
        const routesObject = response.data.data;
        let flattenedRoutes = [];
        for (const key in routesObject) {
          if (Array.isArray(routesObject[key])) {
            const routes = routesObject[key].map(route => `/${route.route_url}`);
            flattenedRoutes = flattenedRoutes.concat(routes);
          }
        }
        
        commit('SET_ALLOWED_ROUTES', flattenedRoutes);
        dispatch('filterMenuItems');
      } else {
        console.error("Invalid API response format for menu items:", response);
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('token_set');
        localStorage.removeItem('profile_id');
        commit('CLEAR_MENU_STATE');
      } else {
        console.error("Error fetching menu items:", error);
      }
    }
  },
  filterMenuItems({ commit, state }) {
    const allowed = state.allowedRoutes;
    const isRouteAllowed = (path) => allowed.includes(path);
    
    const filtered = state.data.map((menuItem) => {
        if (menuItem.type === 'headtitle') {
          return menuItem;
        }

        if (menuItem.children) {
          const filteredChildren = menuItem.children.filter((child) =>
              isRouteAllowed(child.path)
          );

          if (filteredChildren.length > 0) {
            return { ...menuItem, children: filteredChildren };
          }
        } else if (menuItem.path && isRouteAllowed(menuItem.path)) {
          return menuItem;
        }

        return null;
      }).filter(Boolean);
      
    commit('SET_FILTERED_MENU_ITEMS', filtered);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};